
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

@Component
export default class AnswerBlockSelect extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;

  @Watch("input")
  updateAnswer(value: string) {
    if (this.index == null) return;

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: this.items.find((item) => item.value == value) ? value : "",
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });
  }

  input = "";

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index == null || !answer) return;

    this.input = answer.value;
  }

  get items() {
    if (this.answerBlockData.loop_answer_items != null)
      return this.answerBlockData.loop_answer_items.map((v) => ({ value: v, label: v }));
    if (this.answerBlockData.answer_select_items.values !== "")
      return this.answerBlockData.answer_select_items.values
        .split(",,")
        .map((v) => ({ value: v, label: v }));

    return [];
  }

  get searchable() {
    return this.answerBlockData.is_search_possible;
  }
}
